import axios from 'axios';
import { MOTOR_DOC_NAMES, MOTOR_UPLOAD_ACCEPT, MOTOR_UPLOAD_MAX_BYTES } from '@/constants/motorDocuments';

export function createMotorUploadState() {
  return {
    logbook: { file: null, loading: false, done: false },
    kra: { file: null, loading: false, done: false },
    nationalId: { file: null, loading: false, done: false },
  };
}

export function validateMotorUploadFile(file) {
  if (!file) return 'No file selected';
  if (file.size > MOTOR_UPLOAD_MAX_BYTES) return 'File exceeds 6 MB limit.';
  if (!MOTOR_UPLOAD_ACCEPT.includes(file.type)) return 'Only PDF, JPEG, PNG files allowed.';
  return null;
}

function readFileBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      const match = /,(.+)/.exec(reader.result);
      resolve(match ? match[1] : '');
    };
    reader.onerror = () => reject(new Error('FileReader failed'));
    reader.readAsDataURL(file);
  });
}

/**
 * Upload one motor KYC document to quotation upload API.
 * @param {object} params
 * @param {File} params.file
 * @param {string} params.docName — MOTOR_DOC_NAMES value
 * @param {object} params.form — { fullName, email, mobileNumber, idNumber, kraPinNumber }
 */
export async function uploadMotorDocument({ file, docName, form }) {
  const err = validateMotorUploadFile(file);
  if (err) throw new Error(err);

  const base64 = await readFileBase64(file);
  await axios.post(
    '/customer/quotation/upload',
    {
      fileName: file.name,
      kraPinNumber: form.kraPinNumber || form.idNumber || '',
      idNumber: form.idNumber || '',
      img64: base64,
      bucket: 'gi-policies',
      phoneNumber: form.mobileNumber || '',
      email: form.email || '',
      fullName: form.fullName || '',
      documentType: docName,
      travelType: null,
    },
    { timeout: 60000, _skipErrorRedirect: true },
  );
}

export async function uploadMotorDocumentByKey(uploads, key, form) {
  const slot = uploads[key];
  if (!slot?.file || slot.done) return;
  const docName = MOTOR_DOC_NAMES[key] || key;
  slot.loading = true;
  try {
    await uploadMotorDocument({ file: slot.file, docName, form });
    slot.done = true;
  } finally {
    slot.loading = false;
  }
}

export { MOTOR_DOC_NAMES };
